import React from 'react';

const especificaciones = [
    { categoria: 'Follaje 3D', material: 'HDPE', uso: 'Interior y exterior', formatos: 'Panel', icono: '3d' },
    { categoria: 'Follaje Premium', material: 'HDPE', uso: 'Interior y exterior', formatos: 'Panel y rollo', icono: 'premium' },
    { categoria: 'Follaje Estándar', material: 'LDPE', uso: 'Interior', formatos: 'Panel', icono: 'estandar' },
    { categoria: 'Panel de Flores', material: 'Poliéster', uso: 'Interior', formatos: 'Panel y rollo', icono: 'flores' },
    { categoria: 'Expandible (Madera y Poliéster)', material: 'Madera y poliéster', uso: 'Interior', formatos: 'Plegable', icono: 'expandible' },
    { categoria: 'Expandible (Madera y HDPE)', material: 'Madera y HDPE', uso: 'Interior y exterior', formatos: 'Plegable', icono: 'expandible' },
    { categoria: 'Lona', material: 'Nylon y poliéster', uso: 'Interior', formatos: 'Lona', icono: 'lona' }
];

// Iconografía propia en SVG inline (sin depender de una fuente de íconos externa)
const iconos = {
    '3d': (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 8l8-4 8 4-8 4-8-4z" />
            <path d="M4 8v8l8 4 8-4V8" />
            <path d="M12 12v8" />
        </svg>
    ),
    premium: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2l3 6 6 1-4.5 4.3L17.5 20 12 16.8 6.5 20l1-6.7L3 9l6-1 3-6z" />
        </svg>
    ),
    estandar: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <rect x="4" y="4" width="16" height="16" rx="1.5" />
        </svg>
    ),
    flores: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="2.6" />
            <circle cx="12" cy="16" r="2.6" />
            <circle cx="8" cy="12" r="2.6" />
            <circle cx="16" cy="12" r="2.6" />
            <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
        </svg>
    ),
    expandible: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 12l4-6 4 6 4-6 4 6 2-3" />
        </svg>
    ),
    lona: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="5" width="18" height="14" rx="1.5" />
            <path d="M3 15l5-5 4 4 4-3 5 4" />
        </svg>
    )
};

const IconoSol = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M2 12h2M20 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
    </svg>
);

const IconoCasa = () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 11l9-7 9 7" />
        <path d="M5 10v10h14V10" />
    </svg>
);

// Ancho fijo vía grid (no minWidth) para que las tres columnas midan siempre lo mismo,
// sin importar si el contenido es "Interior" o "Interior y exterior".
const Chip = ({ etiqueta, valor, icono }) => (
    <div className="d-flex flex-column bg-light rounded px-2 py-1">
        <span className="text-muted text-uppercase" style={{ fontSize: '9px', letterSpacing: '0.5px' }}>
            {etiqueta}
        </span>
        <span className="d-flex align-items-center font-weight-700" style={{ fontSize: '12px' }}>
            {icono && <span className="text-primary me-1 d-inline-flex flex-shrink-0">{icono}</span>}
            {valor}
        </span>
    </div>
);

const EspecificacionesFollaje = () => {
    return (
        <section id="especificaciones" className="bg-light py-1-9 py-lg-2-9">
            <div className="container">
                <div className="row justify-content-center mb-1-6">
                    <div className="col-lg-10 text-center">
                        <div className="title-style2 mb-1 wow fadeIn" data-wow-delay="100ms">
                            <h2 className="h2">Especificaciones por categoría</h2>
                        </div>
                        <p className="mb-0 text-secondary text-sm">
                            Compara material, uso recomendado y formato antes de elegir tu categoría de follaje
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="bg-white rounded shadow-sm px-1-6 py-1">
                            {especificaciones.map((fila, index) => (
                                <div
                                    key={fila.categoria}
                                    className={`d-flex flex-column flex-lg-row align-items-lg-center justify-content-lg-between py-2 ${index !== especificaciones.length - 1 ? 'border-bottom' : ''}`}
                                >
                                    <div className="d-flex align-items-center mb-2 mb-lg-0" style={{ minWidth: '250px' }}>
                                        <span className="text-primary flex-shrink-0 me-2">{iconos[fila.icono]}</span>
                                        <h3 className="h6 mb-0 font-weight-700" style={{ fontSize: '14px' }}>{fila.categoria}</h3>
                                    </div>

                                    <div
                                        className="d-grid"
                                        style={{ gridTemplateColumns: 'repeat(3, minmax(110px, 160px))', gap: '8px' }}
                                    >
                                        <Chip etiqueta="Material" valor={fila.material} />
                                        <Chip
                                            etiqueta="Uso recomendado"
                                            valor={fila.uso}
                                            icono={fila.uso.includes('exterior') ? <IconoSol /> : <IconoCasa />}
                                        />
                                        <Chip etiqueta="Formatos" valor={fila.formatos} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EspecificacionesFollaje;